import { PageQueryParams } from '../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { UseCompanyConsultationsResponse } from '../useCompanyConsultations/useCompanyConsultations.types';

const PREFIX = '[companyClosedConsultationsQuery]';

export const companyClosedConsultationsQuery = async (params: PageQueryParams) => {
  console.log(PREFIX, `Fetching company closed consultations...`);
  const response = await CONSULTATIONS_ENDPOINTS.allCompanyClosedConsultations(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received company closed consultations.`);
  return json as UseCompanyConsultationsResponse;
};
